<template lang="pug">
  v-select.country-select(@input="onInput" :options="options" :placeholder="placeholder" label="name")
    template(slot="option" slot-scope="option")
      div(@mousedown="select($event, option)") {{ option.name }}
</template>

<script>
import vSelect from 'vue-select'
import countries from '@/data/components/common/countries'

const SEPARATOR = {
  name: '---------------------'
}

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Select Country',
      required: false
    },
    value: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    options: [],
    highlightedOptions: [],
    hasSeparator: false
  }),
  created() {
    this.options = countries.map((c) => c)
  },
  destroyed() {
    this.options = countries
    this.highlightedOptions = []
  },
  methods: {
    select(e, option) {
      if (option.name === SEPARATOR.name) {
        e.stopPropagation()
      }
    },
    onInput(val) {
      this.$emit('input', val)
    },
    highlightCountry(country) {
      if (this.hasSeparator === false) {
        this.options.unshift(SEPARATOR)
        this.hasSeparator = true
      }
      const isHighlighted = this.highlightedOptions.find((ho) => {
        if (ho.code === country || ho.code === country.code) {
          return true
        }
        return false
      })
      if (!isHighlighted) {
        let foundCountryObject
        if (typeof country !== 'object') {
          foundCountryObject = this.options.find((o) => {
            if (o.code === country) {
              return o
            }
            return null
          })
          if (foundCountryObject) {
            this.options.unshift(foundCountryObject)
          }
        } else {
          this.options.unshift(country)
        }
        this.highlightedOptions.push(foundCountryObject || country)
      }
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/CountrySelect.vue